export default {
  models_pending: false,
  models: [],
  lastModified: null
}
